// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_intraday_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { BiddingApprovalMode, BiddingApprovalState, BiddingBidSendErrorCategory, BiddingBidSendStatus, BiddingIntradayOrderStatus, BiddingJepxReconcileOutcome } from "./bidding_common_model_pb";
import { file_bffuser_v1_bidding_common_model } from "./bidding_common_model_pb";
import type { BiddingIntradayMarketAreaGroup } from "./bidding_intraday_market_model_pb";
import { file_bffuser_v1_bidding_intraday_market_model } from "./bidding_intraday_market_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_intraday_model.proto.
 */
export const file_bffuser_v1_bidding_intraday_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_license_type, file_bfftypes_v1_side, file_bffuser_v1_bidding_common_model, file_bffuser_v1_bidding_intraday_market_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * 時間前注文 (BFF mirror)。
 *
 * @generated from message bffuser.v1.BiddingIntradayOrder
 */
export type BiddingIntradayOrder = Message<"bffuser.v1.BiddingIntradayOrder"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 4;
   */
  timeCode: number;

  /**
   * 売/買 方向。
   *
   * @generated from field: bfftypes.v1.Side direction = 5;
   */
  direction: Side;

  /**
   * 注文価格 (円/kWh)。
   *
   * @generated from field: google.type.Decimal price_yen_per_kwh = 6;
   */
  priceYenPerKwh?: Decimal;

  /**
   * 注文量 (MWh)。
   *
   * @generated from field: google.type.Decimal volume_mwh = 7;
   */
  volumeMwh?: Decimal;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalMode approval_mode = 8;
   */
  approvalMode: BiddingApprovalMode;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalState approval_state = 9;
   */
  approvalState: BiddingApprovalState;

  /**
   * @generated from field: bffuser.v1.BiddingIntradayOrderStatus bid_status = 10;
   */
  bidStatus: BiddingIntradayOrderStatus;

  /**
   * 送信状態 (= eSLJ への提出 lifecycle。 承認軸 / 約定軸と直交)。
   *
   * @generated from field: bffuser.v1.BiddingBidSendStatus send_status = 23;
   */
  sendStatus: BiddingBidSendStatus;

  /**
   * 送信失敗の理由カテゴリ / 生 detail (= 失敗時のみ非 UNSPECIFIED / 非空)。
   *
   * @generated from field: bffuser.v1.BiddingBidSendErrorCategory send_error_category = 26;
   */
  sendErrorCategory: BiddingBidSendErrorCategory;

  /**
   * @generated from field: string send_error_detail = 27;
   */
  sendErrorDetail: string;

  /**
   * 約定量 (MWh) / 約定価格 (円/kWh)。 約定後に eSLJ から取得して永続化。
   *
   * @generated from field: optional google.type.Decimal matched_volume_mwh = 24;
   */
  matchedVolumeMwh?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal matched_price_yen_per_kwh = 25;
   */
  matchedPriceYenPerKwh?: Decimal;

  /**
   * JEPX の入札番号 (AC-BIN-003)。 一覧項目の jepx_bid_no と同じ値で、 backend が値を知る札だけ
   * 設定する (番号で紐付けた札と、 送信済で、 取り込み元が自社の client_bid_id の下に番号付きで
   * 並べている札。 #12633)。 値が無い札は未設定。
   *
   * @generated from field: optional string jepx_bid_no = 11;
   */
  jepxBidNo?: string;

  /**
   * 承認申請者 / 申請日時。
   *
   * @generated from field: optional string requested_by = 12;
   */
  requestedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp requested_at = 13;
   */
  requestedAt?: Timestamp;

  /**
   * 承認者 / 承認日時。
   *
   * @generated from field: optional string approved_by = 14;
   */
  approvedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp approved_at = 15;
   */
  approvedAt?: Timestamp;

  /**
   * JEPX 提出 (= 板に出した) 日時。
   *
   * @generated from field: optional google.protobuf.Timestamp submitted_at = 16;
   */
  submittedAt?: Timestamp;

  /**
   * 自動取消 (AC-BIN-017) の予約時刻 = 取下予定日時。 未予約は未設定。
   * 「取下が実際に起きた日時」 は withdrawn_at (= 予定と実績で別 field。 issue #5007)。
   *
   * @generated from field: optional google.protobuf.Timestamp withdraw_at = 17;
   */
  withdrawAt?: Timestamp;

  /**
   * 取下が実際に行われた日時 (= 板取消の実績)。 取下前は未設定。
   *
   * @generated from field: optional google.protobuf.Timestamp withdrawn_at = 28;
   */
  withdrawnAt?: Timestamp;

  /**
   * ゲートクローズ時刻 (= 編集 / 取下の可否判定)。
   *
   * @generated from field: google.protobuf.Timestamp gc_at = 18;
   */
  gcAt?: Timestamp;

  /**
   * 監査情報。 updated_at は楽観ロック基準値も兼ねる。
   *
   * @generated from field: optional string created_by = 19;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 21;
   */
  updatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 22;
   */
  updatedAt?: Timestamp;

  /**
   * 発注主体 (= どの名義で JEPX に発注するか) の紐付け種別。 spot と同じ enum。
   * UNSPECIFIED は、eBalance の外から出して取り込んだ注文で、受渡契約コードが広域マスタに無く
   * 発注主体区分が空欄の時だけ返る (AC-BIN-109a)。 発電として扱わない。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 29;
   */
  issuerType: LicenseType;

  /**
   * 価格種別 (指値 / 成行、 intraday-bidding.md AC-BIN-004d)。 成行の場合
   * price_yen_per_kwh は 0。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderOrderMethod order_method = 30;
   */
  orderMethod: BiddingIntradayOrderOrderMethod;

  /**
   * メモ（自由記述）。 社内限定で JEPX へは送信しない (AC-BIN-004)。
   *
   * @generated from field: optional string memo_free = 31;
   */
  memoFree?: string;

  /**
   * JEPX自由記述欄。 JEPX へ送信される自由記述 (AC-BIN-004)。
   *
   * @generated from field: optional string memo_jepx = 33;
   */
  memoJepx?: string;

  /**
   * 残数量 (MW、 AC-BIN-003)。 注文量 - 約定量 (volume_mwh - matched_volume_mwh、 約定前は
   * volume_mwh)。 状態によらず同じ式で、 札が終わった後 (全約定・部分約定・未約定・取消・失効、
   * AC-BIN-035) は約定しなかった数量になる。 SpotBid / BlockBid の約定量と同じく
   * 永続化しない計算値 (persistence/model/bidding.go 参照)。
   *
   * @generated from field: optional google.type.Decimal remaining_volume_mw = 35;
   */
  remainingVolumeMw?: Decimal;

  /**
   * JEPX 受渡契約コード。 eBalance で作った注文は作成時に決めて保存したコード
   * (AC-BIN-004)、 取り込んだ札 (eBalance の外から出された札。 AC-BIN-106) は外部のコード。
   * コードを保存する前に作られた旧い注文は未設定。
   *
   * @generated from field: optional string delivery_contract_cd = 36;
   */
  deliveryContractCd?: string;

  /**
   * 札を作成したワークフローの業務ID (AC-BIN-003)。 case_id 付きの札作成と自動入札の札に設定し、
   * それ以外は未設定 (AC-BIN-018 の「ワークフローなし」)。
   *
   * @generated from field: optional string workflow_id = 37;
   */
  workflowId?: string;

  /**
   * 対向条件 (AC-BIN-007。 P0 は入力の保存のみで発動の自動実行は P1、 spec の
   * 「※ 対向条件の入力UIのみ提供。 発動の自動実行はP1」参照)。 未設定なら field ごと無い。
   *
   * @generated from field: optional bffuser.v1.BiddingIntradayCounterCondition counter_condition = 38;
   */
  counterCondition?: BiddingIntradayCounterCondition;

  /**
   * 最新の差戻しの日時 / 理由。 承認・提出・差戻し後再編集 (AC-BIN-049) では消えず、 次の差戻しで
   * 上書きされる。 差し戻されているかは approval_state で判断する。
   *
   * @generated from field: optional google.protobuf.Timestamp rejected_at = 43;
   */
  rejectedAt?: Timestamp;

  /**
   * @generated from field: optional string rejected_reason = 44;
   */
  rejectedReason?: string;

  /**
   * 板取消の進行状態 (AC-BIN-008b)。 bid_status とは別軸。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderWithdrawState withdraw_state = 32;
   */
  withdrawState: BiddingIntradayOrderWithdrawState;

  /**
   * 応答時点で取下ボタン (板取消 AC-BIN-008 / 予約取消 AC-BIN-093) を出すか。 backend の値
   * (WITHDRAW の受付条件を満たし、 取消処理中でない) をそのまま返す。 取下ボタンはこの値で出す。
   *
   * @generated from field: bool withdrawable = 34;
   */
  withdrawable: boolean;

  /**
   * 承認段数 (承認申請時の snapshot) と完了した承認段数 (AC-BIN-095)。 意味は
   * internalapi.v1.IntradayOrder の同名 field と同じ (field 番号も揃える)。
   *
   * @generated from field: optional int32 approval_stage_count = 39;
   */
  approvalStageCount?: number;

  /**
   * @generated from field: int32 approved_stage_count = 40;
   */
  approvedStageCount: number;

  /**
   * 承認待ちの札が今待っている段の承認者 member_id (承認申請時の snapshot)。 意味は
   * internalapi.v1.IntradayOrder の同名 field と同じ (field 番号も揃える)。
   * 詳細 (Get) の応答に載り、 状態遷移の応答では空 (一覧は BiddingIntradayOrderListItem の同名 field)。
   *
   * @generated from field: repeated string current_stage_approver_member_ids = 41;
   */
  currentStageApproverMemberIds: string[];

  /**
   * 板取消の失敗が確定した理由 (AC-BIN-008b)。 withdraw_state が FAILED の時だけ非 UNSPECIFIED。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderWithdrawFailureReason withdraw_failure_reason = 42;
   */
  withdrawFailureReason: BiddingIntradayOrderWithdrawFailureReason;

  /**
   * フォーミュラ価格の入力値 (AC-BIN-005)。 フォーミュラで保存した札だけ設定する。
   * price_yen_per_kwh は保存した時点で 1 回計算した固定値 (AC-BIN-020)。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderFormula formula = 45;
   */
  formula?: BiddingIntradayOrderFormula;

  /**
   * 入札方式 (通常 / 戦略、 intraday-bidding.md AC-BIN-005b)。 作成直後は常に NORMAL。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderBidMode bid_mode = 46;
   */
  bidMode: BiddingIntradayOrderBidMode;

  /**
   * 戦略モードのスケジュール (適用日時の昇順)。 通常モードでは空。 戦略モードの
   * price_yen_per_kwh / volume_mwh は最も早い段の値を backend が導出したもの。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayOrderScheduleEntry schedule_entries = 47;
   */
  scheduleEntries: BiddingIntradayOrderScheduleEntry[];

  /**
   * 応答時点で承認・差戻し (AC-BIN-095) を受け付けるか。 backend の値 (承認待ちで対象コマの GC 前、
   * AC-BIN-099) をそのまま返す。 詳細モーダルの「承認する」「差戻し」はこの値が false の時に無効化する。
   * 意味は internalapi.v1.IntradayOrder の同名 field と同じ (field 番号も揃える)。
   *
   * @generated from field: bool approval_actionable = 48;
   */
  approvalActionable: boolean;

  /**
   * 取り込み元 (eSLJ) の一覧から見つからなくなった入札中の札か (AC-BIN-127「要確認」)。 業務
   * ステータス (bid_status) と別軸で、 前回の存在確認で見つかっていた札が完全な存在確認で
   * 見つからず、 札が入札中のあいだだけ true。 印の付け外しは updated_at を動かさない
   * (利用者の操作の照合 AC-BIN-123 に数えない)。 スポットの needs_review と同じ意味。
   *
   * @generated from field: bool needs_review = 50;
   */
  needsReview: boolean;

  /**
   * 要確認になった存在確認の時刻。 needs_review が false の時は未設定。
   *
   * @generated from field: google.protobuf.Timestamp needs_review_since = 51;
   */
  needsReviewSince?: Timestamp;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrder.
 * Use `create(BiddingIntradayOrderSchema)` to create a new message.
 */
export const BiddingIntradayOrderSchema: GenMessage<BiddingIntradayOrder> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 0);

/**
 * 戦略モードのスケジュールの 1 段 (BFF mirror of internalapi.v1.IntradayOrderScheduleEntry)。
 *
 * @generated from message bffuser.v1.BiddingIntradayOrderScheduleEntry
 */
export type BiddingIntradayOrderScheduleEntry = Message<"bffuser.v1.BiddingIntradayOrderScheduleEntry"> & {
  /**
   * 適用日時 (日付込みの絶対時刻)。
   *
   * @generated from field: google.protobuf.Timestamp applied_at = 1;
   */
  appliedAt?: Timestamp;

  /**
   * 価格 (円/kWh、 固定値)。
   *
   * @generated from field: google.type.Decimal price_yen_per_kwh = 2;
   */
  priceYenPerKwh?: Decimal;

  /**
   * 量 (コマ別 MW)。
   *
   * @generated from field: google.type.Decimal volume_mw = 3;
   */
  volumeMw?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderScheduleEntry.
 * Use `create(BiddingIntradayOrderScheduleEntrySchema)` to create a new message.
 */
export const BiddingIntradayOrderScheduleEntrySchema: GenMessage<BiddingIntradayOrderScheduleEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 1);

/**
 * UpdateBiddingIntradayOrderRequest で送る戦略モードのスケジュールの 1 段
 * (BFF mirror of internalapi.v1.IntradayOrderScheduleEntryInput)。
 *
 * @generated from message bffuser.v1.BiddingIntradayOrderScheduleEntryInput
 */
export type BiddingIntradayOrderScheduleEntryInput = Message<"bffuser.v1.BiddingIntradayOrderScheduleEntryInput"> & {
  /**
   * @generated from field: google.protobuf.Timestamp applied_at = 1;
   */
  appliedAt?: Timestamp;

  /**
   * @generated from field: google.type.Decimal price_yen_per_kwh = 2;
   */
  priceYenPerKwh?: Decimal;

  /**
   * @generated from field: google.type.Decimal volume_mw = 3;
   */
  volumeMw?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderScheduleEntryInput.
 * Use `create(BiddingIntradayOrderScheduleEntryInputSchema)` to create a new message.
 */
export const BiddingIntradayOrderScheduleEntryInputSchema: GenMessage<BiddingIntradayOrderScheduleEntryInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 2);

/**
 * 対向条件 (AC-BIN-114)。 4 項目は一体で設定される (部分入力は無い)。
 * 戦略モードの札だけに付けられる (AC-BIN-114)。 入力の経路は未実装で、 付ける・変える編集は
 * 今はすべて domain entity が拒否する。
 *
 * @generated from message bffuser.v1.BiddingIntradayCounterCondition
 */
export type BiddingIntradayCounterCondition = Message<"bffuser.v1.BiddingIntradayCounterCondition"> & {
  /**
   * 監視エリア群 (時間前板のエリア群。 1 件以上・重複なし、 #8480 の EN 判断 (2026-09-28))。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayMarketAreaGroup monitoring_area_groups = 1;
   */
  monitoringAreaGroups: BiddingIntradayMarketAreaGroup[];

  /**
   * 閾値価格 (円/kWh、 0.01〜999、 AC-BIN-114)。
   *
   * @generated from field: google.type.Decimal threshold_price_yen_per_kwh = 2;
   */
  thresholdPriceYenPerKwh?: Decimal;

  /**
   * 発動時価格 (円/kWh、 0.01〜999、 AC-BIN-114)。
   *
   * @generated from field: google.type.Decimal trigger_price_yen_per_kwh = 3;
   */
  triggerPriceYenPerKwh?: Decimal;

  /**
   * 発動時量 (MW、 0.1〜9999.9、 AC-BIN-114)。
   *
   * @generated from field: google.type.Decimal trigger_volume_mw = 4;
   */
  triggerVolumeMw?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayCounterCondition.
 * Use `create(BiddingIntradayCounterConditionSchema)` to create a new message.
 */
export const BiddingIntradayCounterConditionSchema: GenMessage<BiddingIntradayCounterCondition> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 3);

/**
 * List 用 projection。
 *
 * @generated from message bffuser.v1.BiddingIntradayOrderListItem
 */
export type BiddingIntradayOrderListItem = Message<"bffuser.v1.BiddingIntradayOrderListItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: int32 time_code = 4;
   */
  timeCode: number;

  /**
   * @generated from field: bfftypes.v1.Side direction = 5;
   */
  direction: Side;

  /**
   * @generated from field: google.type.Decimal price_yen_per_kwh = 6;
   */
  priceYenPerKwh?: Decimal;

  /**
   * @generated from field: google.type.Decimal volume_mwh = 7;
   */
  volumeMwh?: Decimal;

  /**
   * @generated from field: bffuser.v1.BiddingIntradayOrderStatus bid_status = 8;
   */
  bidStatus: BiddingIntradayOrderStatus;

  /**
   * 承認軸 (= 下書き / 承認申請中 / 承認済 等)。 一覧で承認ステータスを表示するため
   * 含める (= spot list と対称)。
   *
   * @generated from field: bffuser.v1.BiddingApprovalState approval_state = 17;
   */
  approvalState: BiddingApprovalState;

  /**
   * 承認軸の監査情報。 承認案件一覧 (approval-tasks) が申請日時降順ソート・
   * 申請者・承認者列に使う。
   *
   * @generated from field: optional string requested_by = 18;
   */
  requestedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp requested_at = 19;
   */
  requestedAt?: Timestamp;

  /**
   * @generated from field: optional string approved_by = 20;
   */
  approvedBy?: string;

  /**
   * 送信状態 (= 履歴一覧で送信中 / 送信失敗バッジを出すため)。
   *
   * @generated from field: bffuser.v1.BiddingBidSendStatus send_status = 14;
   */
  sendStatus: BiddingBidSendStatus;

  /**
   * 送信失敗の理由カテゴリ / 生 detail (= 失敗時のみ非 UNSPECIFIED / 非空)。
   *
   * @generated from field: bffuser.v1.BiddingBidSendErrorCategory send_error_category = 21;
   */
  sendErrorCategory: BiddingBidSendErrorCategory;

  /**
   * @generated from field: string send_error_detail = 22;
   */
  sendErrorDetail: string;

  /**
   * 約定量 (MWh) / 約定価格 (円/kWh)。 約定後に eSLJ から取得して永続化。
   *
   * @generated from field: optional google.type.Decimal matched_volume_mwh = 15;
   */
  matchedVolumeMwh?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal matched_price_yen_per_kwh = 16;
   */
  matchedPriceYenPerKwh?: Decimal;

  /**
   * 最終約定時刻 (AC-BIN-024 の入札履歴の列、 #9585)。 その札の約定のうち最も新しい
   * 約定日時。 約定が無い札は未設定。
   *
   * @generated from field: optional google.protobuf.Timestamp last_matched_at = 29;
   */
  lastMatchedAt?: Timestamp;

  /**
   * 残数量 (MW、 AC-BIN-024 / AC-BIN-003 の一覧列)。 注文量 - 約定量 (札が終わった後は
   * 約定しなかった数量)。 BiddingIntradayOrder.remaining_volume_mw と同じ式。
   *
   * @generated from field: optional google.type.Decimal remaining_volume_mw = 30;
   */
  remainingVolumeMw?: Decimal;

  /**
   * 一覧でも GC 判定したい (= 編集ボタン活性制御) ので含める。
   *
   * @generated from field: google.protobuf.Timestamp gc_at = 9;
   */
  gcAt?: Timestamp;

  /**
   * 監査情報。
   *
   * @generated from field: optional string created_by = 10;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 12;
   */
  updatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: Timestamp;

  /**
   * 発注主体 (= 一覧の発注主体列)。
   * UNSPECIFIED は、eBalance の外から出して取り込んだ注文で、受渡契約コードが広域マスタに無く
   * 発注主体区分が空欄の時だけ返る (AC-BIN-109a)。 発電として扱わない。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 23;
   */
  issuerType: LicenseType;

  /**
   * 価格種別 (指値 / 成行、 intraday-bidding.md AC-BIN-004d)。 成行の場合
   * price_yen_per_kwh は 0。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderOrderMethod order_method = 24;
   */
  orderMethod: BiddingIntradayOrderOrderMethod;

  /**
   * 札を作成したワークフローの業務ID。 case_id 付きの札作成と自動入札の札に設定し、
   * それ以外は未設定 (AC-BIN-024 / AC-BIN-003 の一覧列)。
   *
   * @generated from field: optional string workflow_id = 31;
   */
  workflowId?: string;

  /**
   * メモ（自由記述）。 社内限定で JEPX へは送信しない (AC-BIN-004 / AC-BIN-003 の一覧列)。
   *
   * @generated from field: optional string memo_free = 26;
   */
  memoFree?: string;

  /**
   * JEPX自由記述欄。 JEPX へ送信される自由記述 (AC-BIN-004 / AC-BIN-003 の一覧列)。
   *
   * @generated from field: optional string memo_jepx = 27;
   */
  memoJepx?: string;

  /**
   * 取下予定日時 (AC-BIN-017 の自動取消予約時刻)。 取下予定がある入札のみ設定、
   * なければ未設定 (AC-BIN-003 の一覧列)。
   *
   * @generated from field: optional google.protobuf.Timestamp withdraw_at = 32;
   */
  withdrawAt?: Timestamp;

  /**
   * JEPX の入札番号 (AC-BIN-003 の一覧列)。 backend が値を知る札だけ設定する: 番号で紐付けた札
   * (取り込み・紐付け・GC 後の照会・板で見つけて直した札) と、 送信済で、 取り込み元が自社の
   * client_bid_id の下に番号付きで並べている札 (#12633)。 値が無い札は未設定。 番号を紐付けたかは
   * known_on_board_by_bid_no で返す。
   *
   * @generated from field: optional string jepx_bid_no = 33;
   */
  jepxBidNo?: string;

  /**
   * JEPX 受渡契約コード。 BiddingIntradayOrder.delivery_contract_cd と同じ契約
   * (作成時に決めて保存したコード、 取り込んだ札は外部のコード、 保存前の旧い札は未設定)。
   *
   * @generated from field: optional string delivery_contract_cd = 34;
   */
  deliveryContractCd?: string;

  /**
   * 板取消の進行状態 (AC-BIN-008b)。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderWithdrawState withdraw_state = 25;
   */
  withdrawState: BiddingIntradayOrderWithdrawState;

  /**
   * 応答時点で取下ボタン (板取消 AC-BIN-008 / 予約取消 AC-BIN-093) を出すか。 backend の値
   * (WITHDRAW の受付条件を満たし、 取消処理中でない) をそのまま返す。 取下ボタンはこの値で出す。
   *
   * @generated from field: bool withdrawable = 28;
   */
  withdrawable: boolean;

  /**
   * 板取消の失敗が確定した理由 (AC-BIN-008b)。 withdraw_state が FAILED の時だけ非 UNSPECIFIED。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderWithdrawFailureReason withdraw_failure_reason = 35;
   */
  withdrawFailureReason: BiddingIntradayOrderWithdrawFailureReason;

  /**
   * 承認待ちの札が今待っている段の承認者 member_id (承認申請時の snapshot)。 入札一覧の操作列の
   * 承認者判定 (AC-BIN-098) に使う。 意味は internalapi.v1.IntradayOrderListItem の同名 field と
   * 同じ (field 番号も揃える)。
   *
   * @generated from field: repeated string current_stage_approver_member_ids = 37;
   */
  currentStageApproverMemberIds: string[];

  /**
   * フォーミュラ価格の入力値 (AC-BIN-005)。 BiddingIntradayOrder.formula と同じ (AC-BIN-009 の
   * 提出確認モーダルの併記に使う)。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderFormula formula = 36;
   */
  formula?: BiddingIntradayOrderFormula;

  /**
   * 応答時点で承認・差戻しを受け付けるか。 BiddingIntradayOrder.approval_actionable と同じ値で、
   * 入札一覧の操作列の「承認する」「差戻し」はこの値が false の時に無効化する (AC-BIN-099)。
   * 意味は internalapi.v1.IntradayOrderListItem の同名 field と同じ (field 番号も揃える)。
   *
   * @generated from field: bool approval_actionable = 39;
   */
  approvalActionable: boolean;

  /**
   * この札の約定の JEPX 約定番号 (AC-BIN-022a)。 意味と並びは internalapi.v1.IntradayOrderListItem の
   * 同名 field と同じ (field 番号も揃える)。 ListBiddingIntradayOrdersRequest.include_jepx_execution_nos が
   * true の時だけ載り、 省略時は空。
   *
   * @generated from field: repeated string jepx_execution_nos = 40;
   */
  jepxExecutionNos: string[];

  /**
   * @generated from field: optional string workflow_case_id = 41;
   */
  workflowCaseId?: string;

  /**
   * 取り込み元 (eSLJ) の一覧から見つからなくなった入札中の札か (AC-BIN-127「要確認」)。 業務
   * ステータス (bid_status) と別軸で、 前回の存在確認で見つかっていた札が完全な存在確認で
   * 見つからず、 札が入札中のあいだだけ true。 印の付け外しは updated_at を動かさない
   * (利用者の操作の照合 AC-BIN-123 に数えない)。 スポットの needs_review と同じ意味。
   *
   * @generated from field: bool needs_review = 42;
   */
  needsReview: boolean;

  /**
   * 要確認になった存在確認の時刻。 needs_review が false の時は未設定。
   *
   * @generated from field: google.protobuf.Timestamp needs_review_since = 43;
   */
  needsReviewSince?: Timestamp;

  /**
   * 応答時点で「下書きに戻す」 (AC-BIN-115) を受け付けるか。 backend の値
   * (internalapi.v1.IntradayOrderListItem.returnable_to_draft) をそのまま返す。 一覧の
   * 「下書きに戻す」 はこの値で出す。
   *
   * @generated from field: bool returnable_to_draft = 44;
   */
  returnableToDraft: boolean;

  /**
   * 後から JEPX の板で見つけて直した時刻 (AC-BIN-115)。 backend の値
   * (internalapi.v1.IntradayOrderListItem.found_on_board_at) をそのまま返す。
   *
   * @generated from field: google.protobuf.Timestamp found_on_board_at = 45;
   */
  foundOnBoardAt?: Timestamp;

  /**
   * JEPX に 2 本出ている時の、 同じ札の eBalance の札の id (AC-BIN-115)。 backend の値
   * (internalapi.v1.IntradayOrderListItem.duplicate_of_order_id) をそのまま返す。
   *
   * @generated from field: optional string duplicate_of_order_id = 46;
   */
  duplicateOfOrderId?: string;

  /**
   * GC を過ぎた後に JEPX が受け付けていたかを確かめている札か (AC-BIN-115)。 backend の値
   * (internalapi.v1.IntradayOrderListItem.receipt_checking) をそのまま返す。 true の間は
   * 一覧のステータス列の下に補足を添える。
   *
   * @generated from field: bool receipt_checking = 47;
   */
  receiptChecking: boolean;

  /**
   * 取り込んだ札に対して照合が決めた知らせの種別 (AC-BIN-057 / AC-BIN-115)。 backend の値
   * (internalapi.v1.IntradayOrderListItem.jepx_reconcile_outcome) をそのまま返す。
   *
   * @generated from field: bffuser.v1.BiddingJepxReconcileOutcome jepx_reconcile_outcome = 48;
   */
  jepxReconcileOutcome: BiddingJepxReconcileOutcome;

  /**
   * JEPX 入札番号を紐付けて板にあると分かっている札か (AC-BIN-115)。 backend の値
   * (internalapi.v1.IntradayOrderListItem.known_on_board_by_bid_no) をそのまま返す。
   * 「取消を送りました」 (AC-BIN-057) の判定はこの値で行う (jepx_bid_no は紐付けていない番号も持つ)。
   *
   * @generated from field: bool known_on_board_by_bid_no = 49;
   */
  knownOnBoardByBidNo: boolean;

  /**
   * 自動取消時刻に送信中から取消にした札を GC 後に取り込みが JEPX の板で見つけ、 取消のまま約定ゼロで
   * 残した札か (AC-BIN-115)。 見つけたことで札の見え方が変わらなかったので、 画面は知らせない
   * (#12442 回答 2)。 応答時点の backend の導出 (保存しない)。 それ以外の札は false (受付で板に載ったことを
   * 確かめていた札を GC 後に取消の板の札として見つけた時も false で、 「約定結果で確定しました」 を出す)。
   * jepx_reconcile_outcome (2 本目の知らせの種別) とは別の事実。
   *
   * @generated from field: bool found_on_board_left_unchanged = 50;
   */
  foundOnBoardLeftUnchanged: boolean;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderListItem.
 * Use `create(BiddingIntradayOrderListItemSchema)` to create a new message.
 */
export const BiddingIntradayOrderListItemSchema: GenMessage<BiddingIntradayOrderListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 4);

/**
 * 組織の「手数料自動考慮 (時間前)」の状態 (bid-limits.md AC-BDL-019、
 * intraday-bidding.md AC-BIN-004b)。
 *
 * @generated from message bffuser.v1.BiddingIntradayFeeAutoConsiderState
 */
export type BiddingIntradayFeeAutoConsiderState = Message<"bffuser.v1.BiddingIntradayFeeAutoConsiderState"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * 手数料単価 (円/kWh、 AC-IJM-007a)。 enabled かつ unavailable でない時だけ設定する。
   *
   * @generated from field: google.type.Decimal fee_yen_per_kwh = 2;
   */
  feeYenPerKwh?: Decimal;

  /**
   * ON だが手数料単価を使えない。 true の間は明示入力つきの作成・下書きの編集 (Update) を受け付けない。
   *
   * @generated from field: bool unavailable = 3;
   */
  unavailable: boolean;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayFeeAutoConsiderState.
 * Use `create(BiddingIntradayFeeAutoConsiderStateSchema)` to create a new message.
 */
export const BiddingIntradayFeeAutoConsiderStateSchema: GenMessage<BiddingIntradayFeeAutoConsiderState> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 5);

/**
 * 手数料自動考慮で入札価格を算出したい 1 行 (一括作成は行を並べる)。
 *
 * @generated from message bffuser.v1.BiddingIntradayFeeAdjustedPriceQuery
 */
export type BiddingIntradayFeeAdjustedPriceQuery = Message<"bffuser.v1.BiddingIntradayFeeAdjustedPriceQuery"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.Side direction = 2;
   */
  direction: Side;

  /**
   * 希望価格 (円/kWh)。 手数料自動考慮が OFF の組織では入札価格として扱う。
   *
   * @generated from field: google.type.Decimal desired_price_yen_per_kwh = 3;
   */
  desiredPriceYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayFeeAdjustedPriceQuery.
 * Use `create(BiddingIntradayFeeAdjustedPriceQuerySchema)` to create a new message.
 */
export const BiddingIntradayFeeAdjustedPriceQuerySchema: GenMessage<BiddingIntradayFeeAdjustedPriceQuery> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 6);

/**
 * 保存済みの入札価格から、 手数料自動考慮 ON でその入札価格になる希望価格を逆算したい 1 行
 * (入札編集モーダルの希望価格の初期値。 AC-BIN-004b・AC-BIN-007)。
 *
 * @generated from message bffuser.v1.BiddingIntradayDesiredPriceQuery
 */
export type BiddingIntradayDesiredPriceQuery = Message<"bffuser.v1.BiddingIntradayDesiredPriceQuery"> & {
  /**
   * @generated from field: bfftypes.v1.Side direction = 1;
   */
  direction: Side;

  /**
   * 保存済みの入札価格 (円/kWh)。
   *
   * @generated from field: google.type.Decimal order_price_yen_per_kwh = 2;
   */
  orderPriceYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayDesiredPriceQuery.
 * Use `create(BiddingIntradayDesiredPriceQuerySchema)` to create a new message.
 */
export const BiddingIntradayDesiredPriceQuerySchema: GenMessage<BiddingIntradayDesiredPriceQuery> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 7);

/**
 * BiddingIntradayDesiredPriceQuery 1 行の逆算結果。
 *
 * @generated from message bffuser.v1.BiddingIntradayDesiredPriceResult
 */
export type BiddingIntradayDesiredPriceResult = Message<"bffuser.v1.BiddingIntradayDesiredPriceResult"> & {
  /**
   * 売り: 入札価格 − 手数料単価、 買い: 入札価格 + 手数料単価。 手数料自動考慮が ON で
   * 手数料単価を使える時だけ設定する (OFF・単価を使えない時は未設定 = 保存済みの入札価格が
   * そのまま入力欄の値になる)。
   *
   * @generated from field: google.type.Decimal desired_price_yen_per_kwh = 1;
   */
  desiredPriceYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayDesiredPriceResult.
 * Use `create(BiddingIntradayDesiredPriceResultSchema)` to create a new message.
 */
export const BiddingIntradayDesiredPriceResultSchema: GenMessage<BiddingIntradayDesiredPriceResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 8);

/**
 * BiddingIntradayFeeAdjustedPriceQuery 1 行の算出結果。
 *
 * @generated from message bffuser.v1.BiddingIntradayFeeAdjustedPriceResult
 */
export type BiddingIntradayFeeAdjustedPriceResult = Message<"bffuser.v1.BiddingIntradayFeeAdjustedPriceResult"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayFeeAdjustedPriceStatus status = 1;
   */
  status: BiddingIntradayFeeAdjustedPriceStatus;

  /**
   * 入札価格 (円/kWh)。 OFF は希望価格のまま、 ADJUSTED / OUT_OF_RANGE は算出値。
   * INDETERMINATE では設定しない。
   *
   * @generated from field: google.type.Decimal order_price_yen_per_kwh = 2;
   */
  orderPriceYenPerKwh?: Decimal;

  /**
   * OUT_OF_RANGE の時だけ設定する。
   *
   * @generated from field: bffuser.v1.BiddingIntradayFeeAdjustedPriceViolation violation = 3;
   */
  violation?: BiddingIntradayFeeAdjustedPriceViolation;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayFeeAdjustedPriceResult.
 * Use `create(BiddingIntradayFeeAdjustedPriceResultSchema)` to create a new message.
 */
export const BiddingIntradayFeeAdjustedPriceResultSchema: GenMessage<BiddingIntradayFeeAdjustedPriceResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 9);

/**
 * 算出した入札価格が外れた境界 (AC-BIN-104。 文言の SoT は spot-bidding.md AC-BSP-106)。
 * JEPX の値域と入札制限の両方を外れる時は、 希望価格の入力可能範囲が狭くなる方を返す。
 *
 * @generated from message bffuser.v1.BiddingIntradayFeeAdjustedPriceViolation
 */
export type BiddingIntradayFeeAdjustedPriceViolation = Message<"bffuser.v1.BiddingIntradayFeeAdjustedPriceViolation"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayFeeAdjustedPriceBound bound = 1;
   */
  bound: BiddingIntradayFeeAdjustedPriceBound;

  /**
   * @generated from field: bffuser.v1.BiddingIntradayFeeAdjustedPriceBoundSource source = 2;
   */
  source: BiddingIntradayFeeAdjustedPriceBoundSource;

  /**
   * 外れた境界そのもの (JEPX の 0.01 / 999、 または入札制限の設定値)。
   *
   * @generated from field: google.type.Decimal bound_order_price_yen_per_kwh = 3;
   */
  boundOrderPriceYenPerKwh?: Decimal;

  /**
   * 入札価格がちょうど境界になる希望価格。
   *
   * @generated from field: google.type.Decimal desired_price_bound_yen_per_kwh = 4;
   */
  desiredPriceBoundYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayFeeAdjustedPriceViolation.
 * Use `create(BiddingIntradayFeeAdjustedPriceViolationSchema)` to create a new message.
 */
export const BiddingIntradayFeeAdjustedPriceViolationSchema: GenMessage<BiddingIntradayFeeAdjustedPriceViolation> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 10);

/**
 * 作成・下書きの編集で、 画面がプレビューで見ていた手数料自動考慮 (時間前) の状態と希望価格を
 * 渡し、 入札価格の算出を backend に任せるための入力 (AC-BIN-004b)。 拒否条件は
 * internalapi.v1.IntradayOrderFeeAutoConsiderInput を参照。
 *
 * @generated from message bffuser.v1.BiddingIntradayOrderFeeAutoConsiderInput
 */
export type BiddingIntradayOrderFeeAutoConsiderInput = Message<"bffuser.v1.BiddingIntradayOrderFeeAutoConsiderInput"> & {
  /**
   * 希望価格 (円/kWh)。
   *
   * @generated from field: google.type.Decimal desired_price_yen_per_kwh = 1;
   */
  desiredPriceYenPerKwh?: Decimal;

  /**
   * プレビューで見ていた手数料単価 (BiddingIntradayFeeAutoConsiderState.fee_yen_per_kwh)。
   * enabled のときだけ設定する。
   *
   * @generated from field: google.type.Decimal fee_yen_per_kwh = 2;
   */
  feeYenPerKwh?: Decimal;

  /**
   * プレビューで見ていた手数料自動考慮の ON/OFF (BiddingIntradayFeeAutoConsiderState.enabled)。
   *
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderFeeAutoConsiderInput.
 * Use `create(BiddingIntradayOrderFeeAutoConsiderInputSchema)` to create a new message.
 */
export const BiddingIntradayOrderFeeAutoConsiderInputSchema: GenMessage<BiddingIntradayOrderFeeAutoConsiderInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 11);

/**
 * フォーミュラ価格の入力値 (BFF mirror、 backend `IntradayOrderFormula` と 1:1。
 * intraday-bidding.md AC-BIN-005: 変数・参照エリア・演算子・オフセット値)。
 *
 * @generated from message bffuser.v1.BiddingIntradayOrderFormula
 */
export type BiddingIntradayOrderFormula = Message<"bffuser.v1.BiddingIntradayOrderFormula"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayFormulaVariable variable = 1;
   */
  variable: BiddingIntradayFormulaVariable;

  /**
   * 参照エリア。 JEPX の 9 エリアのどれか、 またはシステムプライス (変数がスポット約定の
   * 時だけ。 backend の domain が検証する)。
   *
   * @generated from oneof bffuser.v1.BiddingIntradayOrderFormula.reference_area
   */
  referenceArea: {
    /**
     * @generated from field: bfftypes.v1.AreaCode reference_area_code = 2;
     */
    value: AreaCode;
    case: "referenceAreaCode";
  } | {
    /**
     * @generated from field: bool reference_system_price = 3;
     */
    value: boolean;
    case: "referenceSystemPrice";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: bffuser.v1.BiddingIntradayFormulaOperator operator = 4;
   */
  operator: BiddingIntradayFormulaOperator;

  /**
   * オフセット値。 演算子が + / − の時は円/kWh、 × / ÷ の時は倍率。 整数部 9 桁・小数点以下
   * 2 桁まで (backend が検証する)。
   *
   * @generated from field: google.type.Decimal offset = 5;
   */
  offset?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderFormula.
 * Use `create(BiddingIntradayOrderFormulaSchema)` to create a new message.
 */
export const BiddingIntradayOrderFormulaSchema: GenMessage<BiddingIntradayOrderFormula> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 12);

/**
 * 受渡日ごとの新規行数 (BFF mirror、 backend `IntradayOrderCsvDateCount` と 1:1)。
 *
 * @generated from message bffuser.v1.BiddingIntradayCsvDateCount
 */
export type BiddingIntradayCsvDateCount = Message<"bffuser.v1.BiddingIntradayCsvDateCount"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayCsvDateCount.
 * Use `create(BiddingIntradayCsvDateCountSchema)` to create a new message.
 */
export const BiddingIntradayCsvDateCountSchema: GenMessage<BiddingIntradayCsvDateCount> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 13);

/**
 * 時間前入札 CSV の差分プレビュー 1 行 (BFF mirror、 backend
 * `IntradayOrderCsvRowResult` と 1:1)。
 *
 * @generated from message bffuser.v1.BiddingIntradayCsvRowResult
 */
export type BiddingIntradayCsvRowResult = Message<"bffuser.v1.BiddingIntradayCsvRowResult"> & {
  /**
   * CSV のデータ行番号 (ヘッダー行を除く 1 起算)。 エラー文言の「行 N」 と一致する。
   *
   * @generated from field: int32 row_number = 1;
   */
  rowNumber: number;

  /**
   * @generated from field: bffuser.v1.BiddingIntradayCsvRowStatus status = 2;
   */
  status: BiddingIntradayCsvRowStatus;

  /**
   * 表示用のエラー理由 (列の並び順)。 status = ERROR の時のみ非空。
   *
   * @generated from field: repeated string messages = 3;
   */
  messages: string[];

  /**
   * @generated from field: google.type.Date target_date = 4;
   */
  targetDate?: Date;

  /**
   * @generated from field: int32 time_code = 5;
   */
  timeCode: number;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 6;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.Side direction = 7;
   */
  direction: Side;

  /**
   * 発注主体 (= CSV の `発注主体区分` 列を解決した値)。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 8;
   */
  issuerType: LicenseType;

  /**
   * 入札価格 (円/kWh)。 指値で基準価格を使わない行だけ設定する。
   *
   * @generated from field: google.type.Decimal price_yen_per_kwh = 9;
   */
  priceYenPerKwh?: Decimal;

  /**
   * 数量 (MW 建て)。
   *
   * @generated from field: google.type.Decimal volume_mw = 10;
   */
  volumeMw?: Decimal;

  /**
   * 自動取消時刻。 CSV で空欄の行には入札制限のデフォルト取り下げ時刻が入る
   * (デフォルトが「直前」の時は、 その行のコマの GC の時刻)。
   *
   * @generated from field: optional google.protobuf.Timestamp withdraw_at = 11;
   */
  withdrawAt?: Timestamp;

  /**
   * 価格種別 (CSV の `価格種別` 列)。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderOrderMethod order_method = 12;
   */
  orderMethod: BiddingIntradayOrderOrderMethod;

  /**
   * 基準価格・演算子・調整値 (基準価格を使う行だけ設定する。 入札価格は確定時に
   * 計算するため、 差分プレビューでは式のまま返す)。
   *
   * @generated from field: bffuser.v1.BiddingIntradayFormulaVariable reference_price = 13;
   */
  referencePrice: BiddingIntradayFormulaVariable;

  /**
   * @generated from field: bffuser.v1.BiddingIntradayFormulaOperator formula_operator = 14;
   */
  formulaOperator: BiddingIntradayFormulaOperator;

  /**
   * @generated from field: google.type.Decimal formula_value = 15;
   */
  formulaValue?: Decimal;

  /**
   * 基準価格エリア (基準価格を使う行で、 CSV の基準価格エリア列に値がある時だけ
   * 設定する)。 どちらも未設定の行は、 その行のエリアの価格を使う。
   *
   * @generated from oneof bffuser.v1.BiddingIntradayCsvRowResult.formula_reference_area
   */
  formulaReferenceArea: {
    /**
     * @generated from field: bfftypes.v1.AreaCode formula_reference_area_code = 16;
     */
    value: AreaCode;
    case: "formulaReferenceAreaCode";
  } | {
    /**
     * @generated from field: bool formula_reference_system_price = 17;
     */
    value: boolean;
    case: "formulaReferenceSystemPrice";
  } | { case: undefined; value?: undefined };

  /**
   * JEPX自由記述欄。 JEPX へ送信される自由記述 (spec §2 列14)。 空欄の行は未設定。
   *
   * @generated from field: optional string memo_jepx = 18;
   */
  memoJepx?: string;

  /**
   * メモ。 社内限定で JEPX へは送信しない (spec §2 列15)。 空欄の行は未設定。
   *
   * @generated from field: optional string memo_free = 19;
   */
  memoFree?: string;

  /**
   * 手数料自動考慮 ON で `price_yen_per_kwh` (希望価格) から算出した入札価格
   * (intraday-bidding.md AC-BIN-004b)。 固定価格の行だけが対象 (成行・基準価格
   * の行、 手数料自動考慮 OFF の行は未設定)。
   *
   * @generated from field: google.type.Decimal order_price_yen_per_kwh = 20;
   */
  orderPriceYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayCsvRowResult.
 * Use `create(BiddingIntradayCsvRowResultSchema)` to create a new message.
 */
export const BiddingIntradayCsvRowResultSchema: GenMessage<BiddingIntradayCsvRowResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 14);

/**
 * 時間前入札 CSV の確定 (ApplyBiddingIntradayOrderCsv) が取込全体を拒否した時の
 * FailedPrecondition の error detail (BFF mirror、 backend
 * `IntradayOrderCsvApplyRejection` と 1:1)。 確定モーダルはこれを表示し、 error の
 * メッセージの文字列は解析しない。
 *
 * @generated from message bffuser.v1.BiddingIntradayCsvApplyRejection
 */
export type BiddingIntradayCsvApplyRejection = Message<"bffuser.v1.BiddingIntradayCsvApplyRejection"> & {
  /**
   * 行エラー (CSV のデータ行順。 1 行に複数の違反があれば違反ごとに 1 件)。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayCsvApplyRowError row_errors = 1;
   */
  rowErrors: BiddingIntradayCsvApplyRowError[];

  /**
   * 行番号を持たない、 ファイル全体が理由の表示用の文言。
   *
   * @generated from field: repeated string file_messages = 2;
   */
  fileMessages: string[];
};

/**
 * Describes the message bffuser.v1.BiddingIntradayCsvApplyRejection.
 * Use `create(BiddingIntradayCsvApplyRejectionSchema)` to create a new message.
 */
export const BiddingIntradayCsvApplyRejectionSchema: GenMessage<BiddingIntradayCsvApplyRejection> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 15);

/**
 * BiddingIntradayCsvApplyRejection の行エラー 1 件 (BFF mirror、 backend
 * `IntradayOrderCsvApplyRowError` と 1:1)。
 *
 * @generated from message bffuser.v1.BiddingIntradayCsvApplyRowError
 */
export type BiddingIntradayCsvApplyRowError = Message<"bffuser.v1.BiddingIntradayCsvApplyRowError"> & {
  /**
   * CSV のデータ行番号 (ヘッダー行を除く 1 起算)。
   *
   * @generated from field: int32 row_number = 1;
   */
  rowNumber: number;

  /**
   * 表示用のエラー理由 (「行 N: 」で始まる文言)。
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * 時間をおくと解消しうる行エラー (AC-BCI-030 / 032)。
   *
   * @generated from field: bool retry_later = 3;
   */
  retryLater: boolean;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayCsvApplyRowError.
 * Use `create(BiddingIntradayCsvApplyRowErrorSchema)` to create a new message.
 */
export const BiddingIntradayCsvApplyRowErrorSchema: GenMessage<BiddingIntradayCsvApplyRowError> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_model, 16);

/**
 * BiddingIntradayOrderBidMode mirrors backend internalapi.v1.IntradayOrderBidMode
 * 1:1 (wire value 一致)。 入札方式 (通常 / 戦略、 AC-BIN-005b)。
 *
 * @generated from enum bffuser.v1.BiddingIntradayOrderBidMode
 */
export enum BiddingIntradayOrderBidMode {
  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BID_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BID_MODE_NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BID_MODE_STRATEGY = 2;
   */
  STRATEGY = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayOrderBidMode.
 */
export const BiddingIntradayOrderBidModeSchema: GenEnum<BiddingIntradayOrderBidMode> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 0);

/**
 * BiddingIntradayOrderOrderMethod mirrors backend
 * internalapi.v1.IntradayOrderOrderMethod 1:1 (wire value names match). 指値 /
 * 成行 (spec docs/specs/bidding/intraday-bidding.md AC-BIN-004d /
 * bid-limits.md AC-BDL-012)。
 *
 * @generated from enum bffuser.v1.BiddingIntradayOrderOrderMethod
 */
export enum BiddingIntradayOrderOrderMethod {
  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_ORDER_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_ORDER_METHOD_LIMIT = 1;
   */
  LIMIT = 1,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_ORDER_METHOD_MARKET = 2;
   */
  MARKET = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayOrderOrderMethod.
 */
export const BiddingIntradayOrderOrderMethodSchema: GenEnum<BiddingIntradayOrderOrderMethod> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 1);

/**
 * BiddingIntradayOrderWithdrawState mirrors backend
 * internalapi.v1.IntradayOrderWithdrawState 1:1 (AC-BIN-008b)。
 *
 * @generated from enum bffuser.v1.BiddingIntradayOrderWithdrawState
 */
export enum BiddingIntradayOrderWithdrawState {
  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_WITHDRAW_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_WITHDRAW_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_WITHDRAW_STATE_FAILED = 2;
   */
  FAILED = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayOrderWithdrawState.
 */
export const BiddingIntradayOrderWithdrawStateSchema: GenEnum<BiddingIntradayOrderWithdrawState> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 2);

/**
 * BiddingIntradayOrderWithdrawFailureReason mirrors backend
 * internalapi.v1.IntradayOrderWithdrawFailureReason 1:1 (AC-BIN-008b)。
 *
 * @generated from enum bffuser.v1.BiddingIntradayOrderWithdrawFailureReason
 */
export enum BiddingIntradayOrderWithdrawFailureReason {
  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_WITHDRAW_FAILURE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_WITHDRAW_FAILURE_REASON_RETRY_LIMIT = 1;
   */
  RETRY_LIMIT = 1,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_WITHDRAW_FAILURE_REASON_GATE_CLOSED = 2;
   */
  GATE_CLOSED = 2,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_WITHDRAW_FAILURE_REASON_FILLED = 3;
   */
  FILLED = 3,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayOrderWithdrawFailureReason.
 */
export const BiddingIntradayOrderWithdrawFailureReasonSchema: GenEnum<BiddingIntradayOrderWithdrawFailureReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 3);

/**
 * IntradayOrderWriteBlockedReason mirrors backend
 * internalapi.v1.IntradayOrderWriteBlockedReason 1:1 (wire value names
 * match). See the backend enum's godoc for the typed-vocabulary contract
 * (not a wire message field; google.rpc.ErrorInfo.reason stays a generic
 * string)。 生成された TS enum と
 * `Record<IntradayOrderWriteBlockedReason, entry | undefined>` により frontend
 * は全 reason の網羅を tsc で担保する。
 *
 * 値名は backend 側と完全一致させる (frontend は google.rpc.ErrorInfo.reason の
 * 文字列をこの mirror の descriptor で解決するため。
 * go/internal/lint/filechecks/protocontract が pin する)。
 *
 * @generated from enum bffuser.v1.IntradayOrderWriteBlockedReason
 */
export enum IntradayOrderWriteBlockedReason {
  /**
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 受付開始 (受渡日前日 12:00 JST、 intraday-bidding.md AC-BIN-089c) より前。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_BEFORE_ACCEPTANCE_START = 1;
   */
  BEFORE_ACCEPTANCE_START = 1,

  /**
   * テナント設定の入札制限 (bid-limits.md §2-2) の価格上下限・上限数量(1札) を
   * 外れた札 (intraday-bidding.md AC-BIN-015 / AC-BIN-097)。 ErrorInfo.metadata
   * に違反した軸の設定値 (`priceMinLimit` / `priceMaxLimit` / `qtyMaxLimit`) を積む。
   * 戦略モードの札は違反した段の値 (`priceMinValue` / `priceMaxValue` /
   * `qtyMaxValue`) も積む (違反したのが最も早い段とは限らないため)。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_BID_LIMIT_VIOLATION = 2;
   */
  BID_LIMIT_VIOLATION = 2,

  /**
   * 戦略モードのスケジュールに、 適用日時が「開場時刻 ≤ 適用日時 < GC」 を外れた段が
   * ある (intraday-bidding.md AC-BIN-005b)。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_SCHEDULE_APPLIED_AT_OUT_OF_WINDOW = 3;
   */
  SCHEDULE_APPLIED_AT_OUT_OF_WINDOW = 3,

  /**
   * 作成・下書きの編集の手数料自動考慮の明示入力に対し、 組織の ON/OFF・手数料単価が
   * プレビュー時と違う・単価を使えない (AC-BIN-004b)。 フォーミュラの作成・更新では、 保存する
   * 時点の設定が ON で単価を使えない時に発生する (treat_fee_auto_consider_as_off を true にした
   * 作成・更新では発生しない)。 画面はプレビューを取り直して再表示する。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_FEE_AUTO_CONSIDER_CHANGED = 5;
   */
  FEE_AUTO_CONSIDER_CHANGED = 5,

  /**
   * 手数料自動考慮 ON で算出した入札価格 (フォーミュラは計算結果に加減算した値) が JEPX の
   * 値域または入札制限を外れる (AC-BIN-104)。 作成とフォーミュラの更新で発生する。
   * metadata は積まない。 画面はプレビューを取り直して違反を表示する。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_FEE_ADJUSTED_PRICE_OUT_OF_RANGE = 6;
   */
  FEE_ADJUSTED_PRICE_OUT_OF_RANGE = 6,

  /**
   * 上限数量(コマ計) (bid-limits.md §2-2) を超える (エリア × コマ × 売買) がある
   * (intraday-bidding.md AC-BIN-015 / AC-BIN-097)。 1 札・価格の BID_LIMIT_VIOLATION とは別の理由。
   * ErrorInfo.metadata は backend の同名 reason と同形 (violationCount / violations /
   * firstAreaCode / firstTimeCode / firstDirection / firstTotalMw / firstLimitMw)。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_BID_VOLUME_TOTAL_LIMIT_VIOLATION = 7;
   */
  BID_VOLUME_TOTAL_LIMIT_VIOLATION = 7,

  /**
   * フォーミュラ価格の変数の値を取得できない (AC-BIN-020。 開場前の時間前の変数を含む)。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_FORMULA_VARIABLE_UNAVAILABLE = 8;
   */
  FORMULA_VARIABLE_UNAVAILABLE = 8,

  /**
   * フォーミュラ価格を計算できない (÷ 0、 手数料自動考慮 OFF で計算結果が範囲外)。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_FORMULA_NOT_CALCULABLE = 9;
   */
  FORMULA_NOT_CALCULABLE = 9,

  /**
   * 承認の時点で札の自動取消時刻が現在時刻以前 (AC-BIN-095 / AC-BIN-116)。 承認は
   * 実行されず承認待ちのまま残る。 metadata は積まない。 承認 RPC のみで発生する。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_APPROVAL_WITHDRAW_AT_PASSED = 10;
   */
  APPROVAL_WITHDRAW_AT_PASSED = 10,

  /**
   * 承認・差戻しの時点で対象コマの GC を過ぎている (AC-BIN-099)。 待っても解けない。
   * metadata は積まない。 承認・差戻しの RPC のみで発生する。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_APPROVAL_GC_PASSED = 11;
   */
  APPROVAL_GC_PASSED = 11,

  /**
   * 直接提出の時点で札の自動取消時刻が現在時刻と同じ分か過去 (AC-BIN-116)。
   * 提出せず下書きのまま残る。承認時の同条件は APPROVAL_WITHDRAW_AT_PASSED を使う。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_SUBMIT_WITHDRAW_AT_PASSED = 12;
   */
  SUBMIT_WITHDRAW_AT_PASSED = 12,

  /**
   * 承認申請の時点で札の自動取消時刻が現在時刻と同じ分か過去 (AC-BIN-116)。
   * 申請せず下書きのまま残る。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_REQUEST_WITHDRAW_AT_PASSED = 13;
   */
  REQUEST_WITHDRAW_AT_PASSED = 13,

  /**
   * 札の作成で受渡契約コードを決められない (広域機関に未登録。 AC-BIN-004)。 待っても解けない。
   * code は InvalidArgument。 metadata は積まない。 作成 RPC のみで発生する (一括作成は 1 札ごとの作成)。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_DELIVERY_CONTRACT_CODE_UNRESOLVED = 14;
   */
  DELIVERY_CONTRACT_CODE_UNRESOLVED = 14,

  /**
   * 「下書きに戻す」 の時点で送信の最中 (AC-BIN-115)。 札は変わらない。 送信が終われば押し直せる。
   *
   * @generated from enum value: INTRADAY_ORDER_WRITE_BLOCKED_REASON_BID_SEND_IN_FLIGHT = 15;
   */
  BID_SEND_IN_FLIGHT = 15,
}

/**
 * Describes the enum bffuser.v1.IntradayOrderWriteBlockedReason.
 */
export const IntradayOrderWriteBlockedReasonSchema: GenEnum<IntradayOrderWriteBlockedReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 4);

/**
 * @generated from enum bffuser.v1.BiddingIntradayFeeAdjustedPriceStatus
 */
export enum BiddingIntradayFeeAdjustedPriceStatus {
  /**
   * @generated from enum value: BIDDING_INTRADAY_FEE_ADJUSTED_PRICE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 手数料自動考慮が OFF。 希望価格をそのまま入札価格とする。
   *
   * @generated from enum value: BIDDING_INTRADAY_FEE_ADJUSTED_PRICE_STATUS_OFF = 1;
   */
  OFF = 1,

  /**
   * ON で算出し、 JEPX の値域・入札制限の範囲内。
   *
   * @generated from enum value: BIDDING_INTRADAY_FEE_ADJUSTED_PRICE_STATUS_ADJUSTED = 2;
   */
  ADJUSTED = 2,

  /**
   * ON で算出したが、 JEPX の値域または入札制限を外れる (AC-BIN-104)。
   *
   * @generated from enum value: BIDDING_INTRADAY_FEE_ADJUSTED_PRICE_STATUS_OUT_OF_RANGE = 3;
   */
  OUT_OF_RANGE = 3,

  /**
   * ON だが手数料単価を使えず算出できない。
   *
   * @generated from enum value: BIDDING_INTRADAY_FEE_ADJUSTED_PRICE_STATUS_INDETERMINATE = 4;
   */
  INDETERMINATE = 4,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayFeeAdjustedPriceStatus.
 */
export const BiddingIntradayFeeAdjustedPriceStatusSchema: GenEnum<BiddingIntradayFeeAdjustedPriceStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 5);

/**
 * @generated from enum bffuser.v1.BiddingIntradayFeeAdjustedPriceBound
 */
export enum BiddingIntradayFeeAdjustedPriceBound {
  /**
   * @generated from enum value: BIDDING_INTRADAY_FEE_ADJUSTED_PRICE_BOUND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_INTRADAY_FEE_ADJUSTED_PRICE_BOUND_MIN = 1;
   */
  MIN = 1,

  /**
   * @generated from enum value: BIDDING_INTRADAY_FEE_ADJUSTED_PRICE_BOUND_MAX = 2;
   */
  MAX = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayFeeAdjustedPriceBound.
 */
export const BiddingIntradayFeeAdjustedPriceBoundSchema: GenEnum<BiddingIntradayFeeAdjustedPriceBound> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 6);

/**
 * @generated from enum bffuser.v1.BiddingIntradayFeeAdjustedPriceBoundSource
 */
export enum BiddingIntradayFeeAdjustedPriceBoundSource {
  /**
   * @generated from enum value: BIDDING_INTRADAY_FEE_ADJUSTED_PRICE_BOUND_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * JEPX 制度の値域 (0.01〜999 円/kWh)。
   *
   * @generated from enum value: BIDDING_INTRADAY_FEE_ADJUSTED_PRICE_BOUND_SOURCE_JEPX = 1;
   */
  JEPX = 1,

  /**
   * テナント設定の入札制限の上下限価格 (bid-limits.md 2-2)。
   *
   * @generated from enum value: BIDDING_INTRADAY_FEE_ADJUSTED_PRICE_BOUND_SOURCE_BID_LIMIT = 2;
   */
  BID_LIMIT = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayFeeAdjustedPriceBoundSource.
 */
export const BiddingIntradayFeeAdjustedPriceBoundSourceSchema: GenEnum<BiddingIntradayFeeAdjustedPriceBoundSource> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 7);

/**
 * 時間前入札 CSV 行ステータス (BFF mirror、 backend
 * `IntradayOrderCsvRowStatus` と 1:1)。 spot / block の共有
 * BiddingCsvRowStatus (CREATED / ERROR の 2 値) では表現できない「対象外」
 * 区分 (エラーではないが取込対象から除外され、 他の行の確定はブロックしない) を
 * 持つため、 時間前 CSV 固有の enum として独立させる。
 *
 * @generated from enum bffuser.v1.BiddingIntradayCsvRowStatus
 */
export enum BiddingIntradayCsvRowStatus {
  /**
   * @generated from enum value: BIDDING_INTRADAY_CSV_ROW_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_INTRADAY_CSV_ROW_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * 対象外（GC済み）。
   *
   * @generated from enum value: BIDDING_INTRADAY_CSV_ROW_STATUS_EXCLUDED_GC_CLOSED = 3;
   */
  EXCLUDED_GC_CLOSED = 3,

  /**
   * 対象外（発注主体区分未登録）。
   *
   * @generated from enum value: BIDDING_INTRADAY_CSV_ROW_STATUS_EXCLUDED_ISSUER_AREA_UNREGISTERED = 4;
   */
  EXCLUDED_ISSUER_AREA_UNREGISTERED = 4,

  /**
   * @generated from enum value: BIDDING_INTRADAY_CSV_ROW_STATUS_ERROR = 5;
   */
  ERROR = 5,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayCsvRowStatus.
 */
export const BiddingIntradayCsvRowStatusSchema: GenEnum<BiddingIntradayCsvRowStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 8);

/**
 * 時間前入札のフォーミュラ価格の基準価格 (BFF mirror、 backend
 * `IntradayFormulaVariable` と 1:1)。
 *
 * @generated from enum bffuser.v1.BiddingIntradayFormulaVariable
 */
export enum BiddingIntradayFormulaVariable {
  /**
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_VARIABLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * スポット約定。
   *
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_VARIABLE_SPOT_EXECUTION = 1;
   */
  SPOT_EXECUTION = 1,

  /**
   * 時間前最終約定。
   *
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_VARIABLE_INTRADAY_LAST = 2;
   */
  INTRADAY_LAST = 2,

  /**
   * 時間前高値。
   *
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_VARIABLE_INTRADAY_HIGH = 3;
   */
  INTRADAY_HIGH = 3,

  /**
   * 時間前安値。
   *
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_VARIABLE_INTRADAY_LOW = 4;
   */
  INTRADAY_LOW = 4,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayFormulaVariable.
 */
export const BiddingIntradayFormulaVariableSchema: GenEnum<BiddingIntradayFormulaVariable> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 9);

/**
 * 時間前入札のフォーミュラ価格の演算子 (BFF mirror、 backend
 * `IntradayFormulaOperator` と 1:1)。
 *
 * @generated from enum bffuser.v1.BiddingIntradayFormulaOperator
 */
export enum BiddingIntradayFormulaOperator {
  /**
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_OPERATOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_OPERATOR_ADD = 1;
   */
  ADD = 1,

  /**
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_OPERATOR_SUBTRACT = 2;
   */
  SUBTRACT = 2,

  /**
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_OPERATOR_MULTIPLY = 3;
   */
  MULTIPLY = 3,

  /**
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_OPERATOR_DIVIDE = 4;
   */
  DIVIDE = 4,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayFormulaOperator.
 */
export const BiddingIntradayFormulaOperatorSchema: GenEnum<BiddingIntradayFormulaOperator> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 10);

/**
 * フォーミュラのプレビューの計算の可否 (BFF mirror、 backend
 * `IntradayFormulaPriceStatus` と 1:1)。
 *
 * @generated from enum bffuser.v1.BiddingIntradayFormulaPriceStatus
 */
export enum BiddingIntradayFormulaPriceStatus {
  /**
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_PRICE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 計算できた。
   *
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_PRICE_STATUS_CALCULATED = 1;
   */
  CALCULATED = 1,

  /**
   * 変数の値を取得できない。 画面は「取得不可」。
   *
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_PRICE_STATUS_VARIABLE_UNAVAILABLE = 2;
   */
  VARIABLE_UNAVAILABLE = 2,

  /**
   * 計算できない (÷ 0、 手数料自動考慮 OFF で計算結果が 0.01〜999 円/kWh を外れる)。
   * 画面は「計算できません」。
   *
   * @generated from enum value: BIDDING_INTRADAY_FORMULA_PRICE_STATUS_NOT_CALCULABLE = 3;
   */
  NOT_CALCULABLE = 3,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayFormulaPriceStatus.
 */
export const BiddingIntradayFormulaPriceStatusSchema: GenEnum<BiddingIntradayFormulaPriceStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_model, 11);

